import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import MailListItem from '@mail/components/MailListItem.vue'
import { mapGetters } from 'vuex'
import * as globalTypes from '@/store/types'
@Component({
    components: { MailListItem },
    computed: {
        ...mapGetters({
            currentPage: globalTypes.CURRENT_PAGE
        })
    },
})
export default class MailList extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Array, default: [] }) items!: []

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    currentPage!: any

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    // 보낸 편지함, 보낼 편지함, 예약메일함 여부
    get isSend(): boolean {
        const wellknownName = this.currentPage.wellKnownFolderName as string
        if (
            ['sentitems', 'outbox', 'drafts'].includes(wellknownName)
        ) {
            return true;
        } else {
            return false;
        }
    }
}